// firebase settings
const firebaseConfig = {
  apiKey: "AIzaSyBvfa99l4fDTww0IInaKo9v7QkxFs59sn8",
  authDomain: "llabs-rkms-maison.firebaseapp.com",
  databaseURL: "https://llabs-rkms-maison.firebaseio.com",
  projectId: "llabs-rkms-maison",
  storageBucket: "llabs-rkms-maison.appspot.com",
  messagingSenderId: "403811779041",
  appId: "1:403811779041:web:f9fca6d020300f918792a0",
  measurementId: "G-5ELX1L8PXD"
};
// spreadsheet JSON API settings
const spreadsheetConfig = {
  url: 'https://script.google.com/macros/s/AKfycbz8AlIUZAnpHvC4-QB2r_40ASAf1MnIg0SqFmrVwOhhq8yr6ow/exec'
};

export { firebaseConfig, spreadsheetConfig }
